var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroDecoration04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.45C0 20.8786 6.02144 26.9 13.45 26.9C20.8786 26.9 26.9 20.8786 26.9 13.45C26.9 6.02143 20.8786 0 13.45 0C6.02144 0 0 6.02143 0 13.45Z",
    fill: "#11B6EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0224 2.10867C13.4701 1.39107 15.5587 3.95681 12.1311 5.27174C8.70343 6.59068 5.40406 10.2829 5.27578 14.2398C5.16754 17.4469 1.05435 15.0335 2.3733 10.2829C3.69224 5.54034 6.8553 2.77015 10.0224 2.10867Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroDecoration04);
export default __webpack_public_path__ + "static/media/hero-decoration-04.efcea26264c1f24d8fbd196fdaa8d236.svg";
export { ForwardRef as ReactComponent };